/**
 * platform feature routes — owned by web-clubs-platform.
 * Add child routes here (this file and everything under features/platform/ belong to the owner).
 * The pathless "platformFeature" route is registered once in src/app/router.tsx (frozen).
 */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../../app/root-route';

export const platformFeature = createRoute({ getParentRoute: () => rootRoute, id: 'platform' });

export const platformRoute = createRoute({
  getParentRoute: () => platformFeature,
  path: '/platform',
  component: lazyRouteComponent(() => import('./pages/PlatformPage'), 'PlatformPage'),
});

export const platformRouteTree = platformFeature.addChildren([platformRoute]);
